(() => {
  angular
    .module('app.settings')
    .controller('AdformPpasModalController', AdformPpasModal);

  AdformPpasModal.$inject = [
    'close',
    'provider',
    'trackingCode',
    'CountriesList',
    'allowedCountries',
  ];

  function AdformPpasModal(
    close,
    provider,
    trackingCode,
    CountriesList,
    allowedCountries,
  ) {
    const vm = this;

    /* ************************************************************* */
    /* *************************** Country ************************* */
    /* ************************************************************* */
    const country = '';
    vm.countries = CountriesList.filter(item => allowedCountries.includes(item.code));
    vm.currentCountry = vm.countries.find(item => item.code === (country || 'DK'));
    vm.onSelectCountry = country => vm.currentCountry = country;


    /* ************************************************************* */
    /* *************************** Actions ************************* */
    /* ************************************************************* */
    vm.onClose = () => {
      close(false, 0);
    };

    vm.onActivate = () => {
      vm.isProcessBusy = true;

      provider.activateIntegrations({
        country: vm.currentCountry.code,
        trackingCode,
      })
      .then(({ data }) => {
        close(data, 0);
      })
      .catch(({ data }) => {
        console.error(data.errorMessage);
      })
      .finally(() => {
        vm.isProcessBusy = false;
      });
    };
  }
})();
